
import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
  subtitleClassName?: string;
  showDefaultImage?: boolean;
  backgroundImage?: string;
}

const PageHeader = ({ 
  title, 
  subtitle, 
  className, 
  subtitleClassName,
  showDefaultImage = true,
  backgroundImage
}: PageHeaderProps) => {
  const backgroundStyle = backgroundImage 
    ? { backgroundImage: `url(${backgroundImage})` }
    : {
      backgroundImage: 'url(/lovable-uploads/530fddbf-4fea-4198-860f-8165d2f8b445.png)'
    };

  return (
    <div className={`relative h-[320px] overflow-hidden flex items-center ${className || 'bg-ai-dark'}`}>
      {/* Background image */}
      {(showDefaultImage || backgroundImage) && (
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={backgroundStyle}
        />
      )}
      <div className="relative w-full translate-y-[70px]">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 text-center">
          {title}
        </h1>
        {subtitle && (
          <p className={`text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto text-center ${subtitleClassName}`}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
